module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-[71]314.15a201e.woff2";